
import {
    FETCH_CUSTOM_MESSAGE_SUCCESS,
    FETCH_CUSTOM_MESSAGE_ERROR,
    FETCH_CUSTOM_MESSAGE_LOADING
} from "../action/index" 

const defaultState= {
    isLoading: true,
    templates: [],
    reminders: [],
    customWaitTime: [],
    custom_missed_calls: [],
    default: [],
    defaultWaitTime: [],
}

const custommessageReducer = (state = defaultState, action ) => {
    switch(action.type){
        case FETCH_CUSTOM_MESSAGE_SUCCESS:
            return {
                ...state, 
                isLoading: false, 
                templates: action.payload.templates, 
                reminders: action.payload.reminders, 
                customWaitTime: action.payload.customWaitTime, 
                custom_missed_calls: action.payload.custom_missed_calls, 
                default: action.payload.default, 
                defaultWaitTime: action.payload.defaultWaitTime, 
            }
        case FETCH_CUSTOM_MESSAGE_LOADING:
            return {...state, isLoading: true, error: null}
        case FETCH_CUSTOM_MESSAGE_ERROR:
            return {...state, isLoading: false, error: "FETCH_CUSTOM_MESSAGE_ERROR"}
        default:
            return {...state};
    }
}

export default custommessageReducer;